import React from 'react'
import { ReportParam } from '../store/store'
import Date from '../../../components/Date'

type Props = {
  param: ReportParam
}

function ParamPill(props: Props) {
  const { 
    param
  } = props

  if (param.type === 'date') {
    return (
      <span key={param.key} className="param-pill">
        {param.label}: <Date date={param.value as Date} />        
      </span>
    )
  } else {
    return (
      <span key={param.key} className="param-pill">
        {param.label}: {param.value}
      </span>
    )
  }
}

export default ParamPill
